<div class="discount">
  <div class="discount__code">
    <ng-container *ngIf="!discount?.generateQrcode && !isQrCodeImage && !discount?.generateBarcode">
      <div
        tuiGroup
        class="promo-code-group"
        [collapsed]="true"
        [tuiHint]="isDesktop ? ('components.loyaltyDiscountDialog.labels.clickToCopyCode' | translate) : ''"
      >
        <button
          tuiButton
          class="promo-code-button"
          type="button"
          appearance="outline-blue-grey"
          [size]="'m'"
          (click)="copyPromoCode()"
        >
          {{ discount.code ?? 'common.labels.noData' | translate }}
        </button>

        <button
          tuiIconButton
          class="tui-group__auto-width-item"
          type="button"
          appearance="outline-blue-grey"
          [size]="'m'"
          [iconStart]="'@tui.copy'"
          (click)="copyPromoCode()"
        ></button>
      </div>
    </ng-container>

    <ng-container *ngIf="discount?.generateQrcode && !isQrCodeImage">
      <qrcode
        #qrcode
        [qrdata]="discount.code ?? ''"
        [allowEmptyString]="true"
        [alt]="'Product QR-code'"
        [cssClass]="'center'"
        [colorDark]="'#000000ff'"
        [colorLight]="'#ffffffff'"
        [elementType]="'img'"
        [errorCorrectionLevel]="'Q'"
        [scale]="1"
        [width]="qrCodeImageWidth"
        [margin]="1"
      ></qrcode>
    </ng-container>

    <ng-container *ngIf="discount?.generateBarcode && !isQrCodeImage">
      <app-barcode [value]="discount.code ?? ''" [options]="barcodeOptions"></app-barcode>
    </ng-container>

    <ng-container *ngIf="isQrCodeImage">
      <app-photo
        [type]="'photo'"
        [id]="discount.discountQRCodeFileId"
        [unionId]="externalUnionId"
        [width]="qrCodeImageWidth + 'px'"
      ></app-photo>
    </ng-container>

    <div *ngIf="discount.validTill">
      {{
        'components.discountDialog.labels.validTill' | translate: { value: (discount.validTill | date: 'dd.MM.yyyy') }
      }}
    </div>
  </div>

  <div class="discount__terms">
    <h1 class="title">{{ 'components.loyaltyDiscountDialog.labels.terms' | translate }}:</h1>

    <app-parse-links
      class="description"
      [value]="discount.discountOptions"
      [disableRedirectDialog]="true"
      (externalLink)="saveRedirectLink($event)"
    ></app-parse-links>
  </div>

  <div class="discount__footer">
    <div class="buttons">
      <button
        tuiButton
        class="button"
        type="button"
        appearance="primary"
        [size]="isMobile ? 'm' : 'l'"
        (click)="onClose()"
      >
        {{ 'common.buttons.close' | translate }}
      </button>
    </div>

    <tui-notification size="m" *ngIf="!discount.onlyCode" icon="" class="notification" appearance="success">
      <div>
        {{ 'components.loyaltyDiscountDialog.labels.savingMessage' | translate }}
        <u routerLink="/loyalty/my-product-codes" (click)="onClose()">
          «{{ 'components.loyaltyLpMyProductCodes.labels.myProductCodes' | translate }}»
        </u>
      </div>
    </tui-notification>
  </div>
</div>
